"use client"

import { useState, useEffect } from "react"
import { EmblaOptionsType } from "embla-carousel"
import Image from "next/image"
import Link from "next/link"
import Carousel from "./carousel"
import SideProductsBar from "./side-products-bar"
import TopCategoryBar from "./top-category-bar"
import { ImageItem } from "./types"
import { StoreSettingType } from "@/lib/data/store-settings"
import { Banner } from "../../types/banner"
import { fetchBanners } from "@lib/data/banners"
import { ContactSection } from "@/components/home-page/contact-section"

type HeroClientProps = {
  storeSetting: StoreSettingType
}

const HeroClient = ({ storeSetting }: HeroClientProps) => {
  const [banners, setBanners] = useState<Banner[]>([])
  const OPTIONS: EmblaOptionsType = {
    loop: true,
  }

  useEffect(() => {
    fetchBanners().then(setBanners)
  }, [])

  const heroBanners = banners.filter((b) => b.position === 'hero')
  const leftBanners = banners.filter((b) => b.position === 'left_sidebar')
  const rightBanners = banners.filter((b) => b.position === 'right_sidebar')

  const social_links = Array.isArray(storeSetting?.social_links)
    ? storeSetting.social_links
    : []

  const contact_info =
    storeSetting?.contact_info && typeof storeSetting.contact_info === "object"
      ? storeSetting.contact_info
      : {}

  const getLink = (label: string) =>
    social_links.find((item: any) => item.label === label)?.url || ""

  const socialMediaLinks = {
    whatsapp: "+90533 848 35 59, +90533 876 06 79",
    instagram: getLink("Instagram") || "https://www.instagram.com/101_yapi/",
    facebook: getLink("Facebook") || "https://www.facebook.com/profile.php?id=61589574905696",
  }

  return (
    <div className="relative">
      <div className="fixed left-3 top-38 z-20 hidden w-48 aspect-[16/65] overflow-hidden rounded-xl border border-orange-200 bg-white shadow-lg ultra:block">
        {leftBanners.length > 0 ? (
          <Carousel
            slides={leftBanners.map(b => ({
              id: b.id,
              name: b.title,
              image: b.image_url,
              order_index: 0,
              product_category_id: 0,
              product_category_handle: 'store'
            }))}
            options={OPTIONS}
          />
        ) : (
          <Link href="/store" className="block w-full h-full relative">
            <Image
              src="/images_public/yeniurunbanner.png"
              alt="Left Ad Banner"
              fill
              className="object-cover"
            />
          </Link>
        )}
      </div>
      <div className="fixed right-3 top-38 z-20 hidden w-48 aspect-[16/65] overflow-hidden rounded-xl border border-orange-200 bg-white shadow-lg ultra:block">
        {rightBanners.length > 0 ? (
          <Carousel
            slides={rightBanners.map(b => ({
              id: b.id,
              name: b.title,
              image: b.image_url,
              order_index: 0,
              product_category_id: 0,
              product_category_handle: 'store'
            }))}
            options={OPTIONS}
          />
        ) : (
          <Link href="/store" className="block w-full h-full relative">
            <Image
              src="/images_public/yeniurunbanner.png"
              alt="Right Ad Banner"
              fill
              className="object-cover"
            />
          </Link>
        )}
      </div>

      <div className="content-container my-7 flex flex-col gap-6">
      {heroBanners.length > 0 ? (
        <Carousel
          slides={heroBanners.map(b => ({
            id: b.id,
            name: b.title,
            image: b.image_url,
            order_index: 0,
            product_category_id: 0,
            product_category_handle: 'store'
          }))}
          options={OPTIONS}
        />
      ) : (
        <Link
          href="/store"
          className="group relative overflow-hidden rounded-2xl border border-orange-200 bg-white shadow-sm"
        >
          <div className="relative h-[220px] w-full md:h-[320px] lg:h-[380px]">
            <Image
              src="/images_public/101yapiBanner.png"
              alt="101 Yapi Hero Banner"
              fill
              priority
              className="object-cover transition-transform duration-500 group-hover:scale-[1.02]"
            />
            <div className="pointer-events-none absolute inset-0 bg-gradient-to-r from-black/25 via-black/5 to-transparent" />
          </div>
        </Link>
      )}
      <ContactSection contactInfo={contact_info} socialMediaLinks={socialMediaLinks} />
      {/** Top bar */}
      <TopCategoryBar
        topCategoryItems={
          storeSetting ? storeSetting.home_top_category_images : []
        }
      />
      {/* part with slideshow */}
      <div className=" w-full relative">
        <div className="w-full inset-0 z-10 flex lg:flex-row flex-col gap-6">
          <div className="w-full lg:max-w-[65%] ">
            <Carousel
              slides={
                storeSetting
                  ? storeSetting.home_carousel_images?.sort(
                    (a: ImageItem, b: ImageItem) =>
                      a.order_index - b.order_index
                  )
                  : []
              }
              options={OPTIONS}
            />
          </div>
          <SideProductsBar
            featuredItems={
              storeSetting ? storeSetting.home_featured_images : []
            }
          />
        </div>
      </div>
      </div>
    </div>
  )
}

export default HeroClient

